import { useDebounce } from "use-debounce";
import { useEvents, useSellarUser } from "../../../hooks";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useBusinessList } from "../../../hooks/api/v2/business/useBusinessList";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { Mixpanel } from "../../../utils/mixpanel";
import { BusinessListElement } from "../../businessListElement/BusinessListElement";
import { SpinnerLegacy } from "../../index";
import { InfiniteList } from "../../infiniteLoading/InfiniteList";

export const BusinessSwitcherContent = ({
  onClick,
  searchValue,
  type,
}: {
  searchValue: string;
  onClick: (businessId?: number) => void;
  type?: "supplier" | "retailer";
}) => {
  const { track } = useEvents();

  const { user, changeBusiness } = useSellarUser();
  const { user: firebaseUser } = useFirebaseUser();
  const [debouncedSearchValue] = useDebounce(searchValue, 500);

  const businessesQuery = useBusinessList(
    {
      search: debouncedSearchValue,
      postcodeSearch: true,
      query: [
        ...(user?.type !== "admin"
          ? [
              Object.freeze({
                type: "hasMembership",
                modifier: "EQUALS",
                value: true,
              }),
            ]
          : []),
        ...(type
          ? [
              Object.freeze({
                type: "type",
                modifier: "EQUALS",
                value: type,
              }),
            ]
          : []),
      ],
      sort: [
        {
          direction: "asc",
          type: "type",
        },
        {
          direction: "asc",
          type: "name",
        },
      ],
      limit: 10,
    },
    {
      enabled: !!firebaseUser && !!user,
    },
  );

  const { business: fromBusiness } = useSellarCurrentBusiness();

  return (
    <>
      {businessesQuery.isLoading ? (
        <SpinnerLegacy />
      ) : !businessesQuery.data?.pages[0]?.length ? (
        <span>No Results</span>
      ) : (
        <InfiniteList
          className={"w-full overflow-visible"}
          query={businessesQuery}
        >
          {businessesQuery.data &&
            businessesQuery.data.pages.map((page) =>
              page.map((business, i) => (
                <BusinessListElement
                  key={i}
                  business={business}
                  onClick={() => {
                    changeBusiness(business.id);
                    track("Account Switched", {
                      toBusinessId: business.id,
                      toBusinessName: business.name,
                      fromBusinessId: fromBusiness?.id,
                      fromBusinessName: fromBusiness?.name,
                    });
                    if (fromBusiness?.id)
                      Mixpanel.groups.resetGroup(fromBusiness.id);
                    Mixpanel.groups.setGroup(business.id);
                    onClick(business.id);
                  }}
                />
              )),
            )}
        </InfiniteList>
      )}
    </>
  );
};
